<h1 mat-dialog-title>TAG</h1>
<div mat-dialog-content>
    <app-tag-viewer class="col-12 px-3" *ngIf="true" [content]='reporte' [showHeader]="false" id="print-section"></app-tag-viewer>
</div>
<div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">Cerrar</button>
</div>
